
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import BorcluForm from "@/components/forms/BorcluForm.vue";
import TakipAlacakliPicker from "@/components/pickers/TakipAlacakliPicker.vue";
import AlacakList from "@/components/lists/AlacakList.vue";
import DokumanForm from "@/components/forms/DokumanForm.vue";
import XmlBankaHesabiSec from "@/components/lists/XmlBankaHesabiSec.vue";
import { TakipEntity } from "@/entity/TakipEntity";
import { VekaletEntity } from "@/entity/VekaletEntity";

interface HataMesaji {
  key: string;
  mesaj: any;
}

@Component({
  components: {
    FormDialog,
    FormWrapper,
    BorcluForm,
    TakipAlacakliPicker,
    AlacakList,
    DokumanForm,
    XmlBankaHesabiSec,
  },
})
export default class TakipEksikBilgilerDialog extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true }) hataMesajlari!: HataMesaji[];
  @Prop({ required: true }) takip!: TakipEntity;
  @Prop() vekaletItem!: VekaletEntity | null;
  @Prop({ default: false }) vekaletLoading!: boolean;
  @Prop({ default: false }) vekaletItemVisible!: boolean;
  @Prop() dokumanVekaletnameAction!: string | undefined;

  get dialogVisible(): boolean {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  getItemTitle(item: HataMesaji): string {
    const titleMap: { [key: string]: string } = {
      'Borçlu': 'Borçlu bilgisi eksik',
      'Alacak': 'Alacak bilgisi eksik',
      'Alacaklı': 'Alacaklı bilgisi eksik',
      'MUVEKKILVEKALETNAME': 'Müvekkil vekaletname eksik',
      'VEKALETVEKALETNAME': 'Vekalet vekaletname eksik',
      'TAKİPVEKALETNAME': 'Takip vekaletname eksik',
      'Takip Talebi IBAN': 'Takip talebi IBAN eksik',
    };
    return titleMap[item.key] || item.mesaj || 'Bilgi eksik';
  }

  getItemDescription(item: HataMesaji): string {
    const descMap: { [key: string]: string } = {
      'Borçlu': 'Lütfen borçlu ekleyiniz.',
      'Alacak': 'Lütfen alacak ekleyiniz.',
      'Alacaklı': 'Lütfen alacaklı ekleyiniz.',
      'MUVEKKILVEKALETNAME': 'Lütfen müvekkil vekaletname ekleyiniz.',
      'VEKALETVEKALETNAME': 'Lütfen vekalet vekaletname ekleyiniz.',
      'TAKİPVEKALETNAME': 'Lütfen takip vekaletname ekleyiniz.',
      'Takip Talebi IBAN': 'Lütfen takip talebi IBAN ekleyiniz.',
    };
    return descMap[item.key] || 'Lütfen eksik bilgiyi tamamlayınız.';
  }

  handleLoad() {
    this.$emit("load");
  }

  handleClose() {
    this.dialogVisible = false;
    this.$emit("close");
  }

  handleSave() {
    this.$emit("save");
  }

  handleXmlDownload(tip: string) {
    this.$emit("xmlDownload", this.takip.id, tip);
  }
}
